"use strict";

exports.__esModule = true;
var _RightEditPanel = require("./RightEditPanel");
Object.keys(_RightEditPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RightEditPanel[key]) return;
  exports[key] = _RightEditPanel[key];
});